import {Alpha3CountryCode, PhoneNumber} from 'platform/components';

import {startsWith} from 'ramda';

import {usePhoneNumbers} from '../../../hooks/usePhoneNumbers';
import {useTenant} from '../../../hooks/useTenant';

export const useGetStructuredPhoneNumber = () => {
  const {countriesOptions} = usePhoneNumbers();
  const {tenantPhoneInfo} = useTenant();

  const getStructuredPhoneNumber = (phoneNumber: string): PhoneNumber => {
    const number = phoneNumber.replace(/\s/g, '');
    const country = countriesOptions?.find((country) => startsWith(country.dialCode, number));

    if (!country) {
      return {
        countryCode: tenantPhoneInfo?.countryCode as Alpha3CountryCode,
        number,
        prefix: tenantPhoneInfo?.prefix,
      };
    }

    return {
      countryCode: country.countryCode,
      number: number.slice(country.dialCode.length),
      prefix: country.dialCode,
    };
  };

  return getStructuredPhoneNumber;
};
